




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { IAppendToBodyComponent } from '@/interfaces';
import { appendToBody } from '@/directives';

@Component({
  name: 'dng-menu',
  directives: { appendToBody }
})
export default class MenuComponent extends Vue implements IAppendToBodyComponent {
  @Prop() public width!: number | undefined;
  @Prop() public title!: string;
  @Prop() public visible!: boolean | undefined;
  @Prop() public height!: number;

  public visibleToggle = false;

  public get toggle(): HTMLElement | undefined { return this.$refs.toggle as HTMLElement; }
  public get show(): boolean { return this.visible ?? this.visibleToggle; }

  public calculatePosition = (el: HTMLElement, context: Vue, width: number, height: number, top: number, left: number): (() => void) | undefined => {
    el.style.top = `${top + 8}px`;
    el.style.left = `${left - ((this.width ? this.width : width) - width) + 10}px`;
    el.style.width = `${this.width ? this.width : width}px`;
    if (this.height) {
      el.style.maxHeight = `${this.height}px`;
    }
    return;
  }
}
